Escalation policies determine the order in which users (or targets) are notified when an alert is triggered.

## Structure

A policy consists of an ordered list of **steps**.

### Steps

Each step defines **who** to notify. You can add multiple targets to a single step.

- **Targets**:
  - **Rotation**: Notifies the currently active user in a rotation.
  - **User**: Notifies a specific user directly.
  - **Slack Channel**: Posts a message to a Slack channel.
  - **Webhook**: Triggers an external webhook.

### Delays

Steps are executed sequentially with a configurable **delay** between them.

- **Step 1** fires immediately when the alert is triggered.
- If the alert is _not acknowledged_ within the delay period of Step 1, the system escalates to **Step 2**, and so on.

## Repetition

If the end of the policy is reached and the alert is still unacknowledged, the policy can **repeat** from the beginning.

- **Repeat Count**: The number of times the full policy chain will loop.
- **Example**: A policy with 3 steps and a repeat count of `1` will execute:
  - Step 1 -> Step 2 -> Step 3 -> (Loop) -> Step 1 -> Step 2 -> Step 3 -> (End).

## Best Practices

- **Use Rotations**: Avoid assigning specific users to policies; use rotations to handle schedule changes easily.
- **Set Reasonable Delays**: Give on-call engineers enough time (e.g., 15-30 minutes) to acknowledge/resolve before escalating to the next level.
- **Fallback Step**: Consider adding a "Manager" or "General Channel" as the final step to ensure no alert goes unnoticed.
